import React, { useEffect, useState } from 'react'
import Loader from '../components/Loader'
import ApiService from '../helpers/api'
import userService from '../helpers/user.service'

export default function Home () {
  const api = new ApiService()
  const [files, setFiles] = useState([])
  const [dirPath, setDirPath] = useState()
  const [loading, setLoading] = useState(true)
  const [downloading, setDownloading] = useState({})
  const fileFormats = ['pdf', 'png', 'ppt', 'jpg', 'xlsx', 'ppt', 'doc', 'xls', 'pptx']
  const [error, setError] = useState('')
  // subdirectoryPath

  useEffect(() => {
    async function getProfile () {
      api.me().then(response => {
        if (response.data) {
          setDirPath('')
          setError('')
        }
      })
        .catch(() => {
          setLoading(false)
          userService.logout()
        })
    }
    getProfile()
  }, [])

  useEffect(() => {
    function listFiles () {
      setLoading(true)
      api.listAllFiles(dirPath).then(response => {
        setFiles(response.data)
        setLoading(false)
        setError()
      }).catch((e) => {
        setError('Ha ocurrido un error al obtener los archivos.')
        setLoading(false)
      })
    }
    if (dirPath?.length || dirPath === '') {
      listFiles()
    }
  }, [dirPath])

  const getFile = (filename) => {
    setDownloading(downloading => ({
      ...downloading,
      [filename]: true
    }))
    api.downloadFile(dirPath, filename).then(response => {
      downloadFile(filename, response.data)
    }).catch(() => {
      setDownloading(downloading => ({
        ...downloading,
        [filename]: false
      }))
    })
  }

  const enterFolder = (folder) => {
    setFiles([])
    setDirPath(`${dirPath}/${folder}`)
  }

  const isFile = (pathname) => {
    return pathname.split('/').pop().indexOf('.') > -1
  }

  const previousPath = () => {
    setFiles([])
    return setDirPath(dirPath.substring(0, dirPath.lastIndexOf('/')))
  }

  const downloadFile = (filename, file) => {
    const url = window.URL.createObjectURL(
      new Blob([file])
    )
    const link = document.createElement('a')
    link.href = url
    link.setAttribute(
      'download',
      filename
    )

    // Add to document
    document.body.appendChild(link)
    // Download
    link.click()
    // Remove
    link.parentNode.removeChild(link)
    setDownloading(downloading => ({
      ...downloading,
      [filename]: false
    }))
  }

  return (
    <section className="wrapper">
      <h3 className="subtitle">Visualización de Documentos</h3>
      {(dirPath?.length > 1 && !loading)
        ? (
      <div className='path'>
      <a onClick={previousPath} className='arrow-back'></a>
      <a onClick={previousPath} className="text">{dirPath}</a>
      </div>
          )
        : ''}
      <div id="archivos">
        <div className="files-holder">
          <Loader loading={loading}/>
          {(error?.length) ? (<p className="text error">{error}</p>) : ''}
          <ul className="files-list">
            {files.map((file, index) => (
              <li className={(!isFile(file)) ? 'item item-carpeta' : (fileFormats.includes('file'.split('.').pop())) ? 'item file ' + file.split('.').pop() : 'item file'} key={index}>
                <p className="name">{file}</p>
                  {(isFile(file))
                    ? (
                <button onClick={() => getFile(file)} >
                  <Loader text="Descargando..." loading={downloading[file] } inButton={true}></Loader>
                  <p style={{ display: downloading[file] ? 'none' : 'block' }}>Descargar archivo</p>
                  </button>)
                    : (
                  <button onClick={() => enterFolder(file)} >
                  <p>Abrir carpeta</p>
                </button>)}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  )
}
